module.exports = __webpack_public_path__ + "static/media/clinic_background.9e3f3c95.png";